<template lang="pug">
#about-event
  .address-block.about-block(v-if="event._embedded.location.id")
    google-map(
      :location="event._embedded.location"
      :name="event._embedded.location.id"
    )
    .content
      .address.block-content
        b-icon(icon="map-marker-outline")
        div
          p.has-text-weight-semibold {{ event._embedded.location.label }}
          div(v-html="event._embedded.location.address.html")
  .content
    .cost-block.about-block(v-if="fromCost > 0")
      .block-content
        b-icon(icon="currency-usd")
        span From {{ fromCost | cents }} per person
    .date-block.about-block
      .block-content
        b-icon(icon="calendar-blank")
        event-date(
          format="MMMM D, YYYY"
          :filter="false"
          :value="event"
        )
    .time-block.about-block(v-if="event.dates.length !== 2 && event.start_time")
      .block-content
        b-icon(icon="clock-outline")
        div
          span(v-if="event.end_time") {{ event.start_time | date('h:mm A') }} &ndash; {{ event.end_time | date('h:mm A') }}
          span(v-else) Starts at {{ event.start_time | date('h:mm A') }}
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import EventDate from '@/components/events/EventDate.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'about-event',
  components: {
    EventDate,
    GoogleMap,
  },
  computed: {
    ...mapGetters({
      event: getterTypes.GET_EVENT,
    }),
    fromCost() {
      if (!this.event.payment_required || this.event._embedded.packages.length === 0) return 0;
      const cheapest = _.minBy(this.event._embedded.packages, p => p.cost);
      if (cheapest) return cheapest.cost;
      return 0;
    },
  },
};
</script>

<style lang="scss">
#about-event {
  @include sidebar;
  .about-block {
    &.address-block {
      .content {
        padding-bottom: 0.5rem;
      }
    }
  }
}
</style>
